import { RouteComponentProps } from "react-router-dom";
import JSEncrypt from 'jsencrypt';
import { PCRouteList, AppRouteList, onlyContentRoutes, publicUrl, publicUrlapi, publicUrlstatic, LOCATION_ORIGN } from "../constants"
import { loginStore } from '../store/pc/index';//全局回退到登录页统一处理
import { ua } from '@weapp/utils'
const CryptoJS = require("crypto-js");

const AES_PUBLIC_KEY = "yoJXYSzZhAOpbEFJklGtqd74X2ChTKOL";

export const mobileReg = /^[0-9]{7,11}$/;
export const mobileLocalReg = /^((13|14|15|17|18|19|16)[0-9]{9})|((\\+|)8869[0-9]{8})|((\\+|)852[569][0-9]{7})|((\\+|)1[2-9][0-9]{2}[2-9][0-9]{6})|((\\+|)84((1(2([0-9])|6([2-9])|88|99))|(9[0-9]{2}))[0-9]{7})|((\\+|)855[0-9]{8})|((\\+|)65[0-9]{8})$/;

export function ebLocaleString(value: any) {
  if (!value) {
    return ''
  }
  if (typeof value === 'string') {
    return value
  }
  if (value.nameAlias) {
    return value.nameAlias || ''
  }
}


// const ua = window.navigator.userAgent;

const PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEOk/WyyJKdAHIfMODFnKg7MBoraFBnL3F18hhLx5n01J5g4hCkmpc5+KQFKIQIA/QWk9m7QBzI/OV9ZDFk54LaWm3xP8C+P1TPp7UVGz3iNDLdvgSxuGEYPmML3NaqkbVlvW7/NlNA3ED4Kao7rR5GUYSdFfbaBoxBFae638hzQIDAQAB-----END PUBLIC KEY-----";

export function fomatParentPath(props: RouteComponentProps) {
  return props.match.url.replace(/\/$/, () => "");
}

export function needLayout() {
  return window.location.pathname.indexOf("/splayout") === 0;
}

export function isMobile() {
  return ua.device !== 'PC';
}
export function isIos() {
  return /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
}
export function isIphone() {
  return /(iPhone)/i.test(navigator.userAgent);
}
export function getCookie(name: string) {
  var ck = document.cookie.replace(new RegExp(name + '=;', 'g'), '').match("(^| )" + name + "=([^;]*)(;|$)");
  if (ck) return unescape(ck[2]);
  return null;
}
export function setCookie(name: string, value: string, domain?: string) {
  if (!domain) {
    domain = window.location.hostname;
  }
  document.cookie = `${name}=${value};domain=${domain};path=/;`;
}

export function mainHost() {
  let host = LOCATION_ORIGN;
  if (host.indexOf("weapp.develop.cn") !== -1) {
    return host;
  }
  host = host.replace('passport', 'weapp');
  if (window.passport_runInfo) {
    return window.passport_runInfo.weappUrl;
  }
  return host;
}
export function passportHost() {
  return window.passport_runInfo?.passportUrl || window.weappTenantEnv?.passportUrl || LOCATION_ORIGN;
}
export function inApp() {
  if (localStorage.getItem("___test_fddfdf")) {
    return true;
  }
  return /weapp/i.test(navigator.userAgent);
}

//判断当前环境是否为私有化
export const isPrivateEnv = () => {
  return window.TEAMS?.deploy === 'private' || window.passport_runInfo?.deployEnv === 'private'
};
//是否隐藏页面头尾
export const onlyShowContent = () => {
  const path = window.location.pathname.replace(publicUrl, '');
  let flag = false;
  onlyContentRoutes.forEach((it: any) => {
    if (path.indexOf(it) === 0) {
      flag = true;
    }
  })
  return flag;
}


const regexs: any = {
  'validation.ip': /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/,
  'validation.ipv4': /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  'validation.ipv6': /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/,
  'validation.telephone': /(^(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})-(\d{1,4})$)|(^(\d{7,8})-(\d{1,4})$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/,
  'validation.pattenChinese': /^([\u2e80-\u9fffa-zA-Z()（） ]+){2,40}$/,
  'validation.name': /^([\u2e80-\u9fff a-zA-Z]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
  'validation.username': /^([\u2e80-\u9fff a-zA-Z()（）]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
  'validation.usernameloose': /^([\u2e80-\u9fff a-zA-Z0-9()（）_-]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
  'validation.company': /^([\u2e80-\u9fff]+){2,}$|^([a-zA-Z]+[\s.]?){0,}[a-zA-Z]+$/,
  'validation.teamName': /^[\u4e00-\u9fa5aa-zA-Z()（） ]+$/,
  'validation.email': /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
  'addteamview.addTeam': /^[\u4e00-\u9fa5aa-zA-Z()（） ]+$/,
  // 'formPlugin.sensitiveWords' : /中[^\u4e00-\u9fa5]*奖|支[^\u4e00-\u9fvalidation.emaila5]*付[^\u4e00-\u9fa5]*宝|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*卡|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*[账帐][^\u4e00-\u9fa5]*户|网[^\u4e00-\u9fa5]*银|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*[账帐][^\u4e00-\u9fa5]*号/g,
  'formPlugin.sensitiveWords.html': /中((?!><)[^\u4e00-\u9fa5])*奖|支((?!><)[^\u4e00-\u9fa5])*付((?!><)[^\u4e00-\u9fa5])*宝|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*卡|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*[账帐]((?!><)[^\u4e00-\u9fa5])*户|网((?!><)[^\u4e00-\u9fa5])*银|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*[账帐]((?!><)[^\u4e00-\u9fa5])*号/g,
  'formPlugin.sensitiveWords.json': /中((?!"},{")[^\u4e00-\u9fa5])*奖|支((?!"},{")[^\u4e00-\u9fa5])*付((?!"},{")[^\u4e00-\u9fa5])*宝|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*卡|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*[账帐]((?!"},{")[^\u4e00-\u9fa5])*户|网((?!"},{")[^\u4e00-\u9fa5])*银|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*[账帐]((?!"},{")[^\u4e00-\u9fa5])*号/g,
  'crm.validation.name': /^([\u2e80-\u9fff]+){2,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
  'crm.validation.chinese': /.*[\u4e00-\u9fa5]+.*$/,
  'sender.writeletterview.address': /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  'emoji.h5.filter': /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
  'im.chat.send.emoji.filter': ['\ud83c[\udf00-\udfff]', '\ud83d[\udc00-\ude4f]', '\ud83d[\ude80-\udeff]'],
  'wechat.convert.cn': new RegExp(/.*[\u4e00-\u9fa5]+.*$/),
  'freeform.textregulareditor.chinese': /^[\u4E00-\u9FA5]+$/,
  'freeform.textregulareditor.number': /^[0-9]+$/,
  'freeform.textregulareditor.letter': /^[A-Za-z]+$/,
  'freeform.textregulareditor.lettersNumbers': /^[A-Za-z0-9]+$/,
  'freeform.textregulareditor.mobile': /^1[3-9]\d{9}$/,
  'freeform.textregulareditor.phone': /(^(\d{7,8})$)|(^\((\d{3,4})\)(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})$)|(^(\d{3,4})(\d{7,8})$)|(^(\d{3,4})(\d{7,8})-(\d{1,4})$)|(^(\d{3,4})-(\d{7,8})-(\d{1,4})$)|(^\((\d{3,4})\)(\d{7,8})-(\d{1,4})$)|(^(\d{7,8})-(\d{1,4})$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/,
  'freeform.textregulareditor.email': /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
  'freeform.textregulareditor.idcard': /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
  'freeform.textregulareditor.postcode': /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/,
  'freeform.textregulareditor.minlength': /^.{10,}$/,
  'freeform.textregulareditor.maxlength': /^.{0,200}$/,
  'freeform.textregulareditor.lengthRange': /^.{10,200}$/
}
export function specialRegex(type: string, value: string) {
  return regexs[type].test(value)
}

// 在自定义登录路由中
export const inCustomLogin = () => {
  return window.location.pathname.indexOf('/customlogin') !== -1;
}


export const inLoginPage = () => {
  const pathname = window.location.pathname.replace(publicUrl, '');
  return pathname.indexOf('/customlogin') !== -1 ||
    pathname.indexOf('/login') !== -1 ||
    pathname.indexOf('/layoutlogin') !== -1 ||
    pathname === '/';
}
// 本地包临时处理 -- 在自定义登录路由中
export const isPrivateLogin = () => {
  return isPrivateEnv() && inLoginPage();
}

//pc白名单检测
export const inPCRouteWhiteList = () => {
  const pathname = window.location.pathname.replace(publicUrl, '') || '/';
  let flag = false;
  PCRouteList.forEach((it: any) => {
    if (pathname.indexOf(`/${it}`) === 0) {
      flag = true;
    }
  })
  if (pathname === '/') {
    return true;
  }
  return flag
}
//H5白名单检测
export const inAppRouteWhiteList = () => {
  const pathname = window.location.pathname.replace(publicUrl, '');
  let flag = false;
  AppRouteList.forEach((it: any) => {
    if (pathname.indexOf(`/${it}`) === 0) {
      flag = true;
    }
  })
  if (pathname === '/') {
    return true;
  }
  return flag
}
//H5白名单检测
export const inDefaultLoginPage = () => {
  const pathname = window.location.pathname.replace(publicUrl, '');
  return pathname === '/' || pathname === '/login';
}

export const controlCountryCodeFc = (arra: any) => {
  let data: any = [];
  arra.forEach((element: any) => {
    // Object.values(element).forEach((it: any) => {
    //   it.forEach((current: any) => {
    const info = element.replace(/\s*/g, "").split('+');
    const label = info[0];
    const id = '+' + info[1];
    const type = Object.keys(element)[0];
    data.push({ label, id, type })
    // });
  });
  return data;
}

export function versionToNum(a: string) {
  let c = a.split('.');
  let num_place = ["", "0", "00", "000", "0000"], r = num_place.reverse();
  for (var i = 0; i < c.length; i++) {
    var len = c[i].length;
    c[i] = r[len] + c[i];
  }
  let res = c.join('');
  return res;
}

export const encryptRsa = (params: any, property: string) => {
  let _publicKey = PUBLIC_KEY;
  if (window.passport_runInfo?.publicKey) {
    try {
      _publicKey = aesDecrypt(window.passport_runInfo?.publicKey)
    } catch (e) {
      console.error(e);
    }
  }
  if (params[property]) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(_publicKey);
    const encrypted = encrypt.encrypt(params[property]);
    params[property] = encrypted;
  }
  return params;
}

export const clearTeamsCookie = () => {
  clearOneCookie("ETEAMSID");
}

export const clearOneCookie = (name: any) => {
  let host = window.location.hostname;
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  //清理当前域
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  //ip地址访问
  if (!reg.test(host)) {
    host = '.' + host;
    for (var i = 0; i < host.length; i++) {
      if (host[i] === '.') {
        let domain = host.substr(i + 1);
        document.cookie = name + "=;domain=" + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = name + "=;domain=." + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    }
  }
}


export function cloneObj(Obj: any) {
  let buf: any;
  if (Obj instanceof Array) {
    buf = [];  //创建一个空的数组
    let i = Obj.length;
    while (i--) {
      buf[i] = cloneObj(Obj[i]);
    }
    return buf;
  } else if (Obj instanceof Object) {
    buf = {};  //创建一个空对象
    for (let k in Obj) {  //为这个对象添加新的属性
      buf[k] = cloneObj(Obj[k]);
    }
    return buf;
  } else {
    return Obj;
  }
}
export function getTokenStorage() {
  return localStorage.getItem('e_userToken') || '';
}
export function setTokenStorage(value: any, loginType: 'password' | 'phoneNumber' | 'thirdLogin' = 'password') {
  setStorage('e_login_type', loginType)
  setStorage('e_userToken', value);
}
// 注册过程与组织过程中需要显示的账号
export function getAccountStorage() {
  return localStorage.getItem('e_account') || '';
}
export function setAccountStorage(value: any) {
  setStorage('e_account', value);
}
// 自动生成的密码
export function getAutoPswStorage() {
  return localStorage.getItem('e_auto_psw') || '';
}
export function setAutoPswStorage(value: any) {
  setStorage('e_auto_psw', value);
}
// 区号
export function getAreaCodeStorage() {
  return localStorage.getItem('e_areaCode') || '';
}
export function setAreaCodeStorage(value: any) {
  setStorage('e_areaCode', value);
}


export function getForgetPwdAccountStorage() {
  return localStorage.getItem('e_forgetPwd_account') || '';
}
export function getStorageByType(type: string) {
  return localStorage.getItem(type) || '';
}
export function setStorage(key: any, value: any) {
  if (!value) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}
export function setSecurityStorage(type: string, value: any) {
  sessionStorage.setItem(type, value)
}
export function getSecurityStorage(type: string) {
  return sessionStorage.getItem(type) || '';
}
export const checkByteCount = (str: string) => {
  let bytesCount = 0;
  for (var i = 0; i < str.length; i++) {
    var username = str.charAt(i);
    if (/^[\u0000-\u00ff]$/.test(username)) //匹配双字节
    {
      bytesCount += 1;
    }
    else {
      bytesCount += 2;
    }
  }
  return bytesCount;
}
export function isIpHost() {
  const host = window.location.hostname;
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  return reg.test(host);
}
/**
 * 校验浏览器合法性
 * @Params version 最低的ie版本(不包括)
 * @returns Boolean
 */
export function checkIsSuitableBrowser(ieVersion = 11) {
  let userAgent = navigator.userAgent;
  let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let fIEVersion = isIE11 ? 11 : parseFloat(RegExp["$1"]);
    if (fIEVersion < ieVersion) {
      return false;
    }
    return true;
  } else {
    // 不是ie浏览器
    // 如果是windows下的safari
    userAgent = userAgent.toLocaleLowerCase()
    const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
    const isWindows = /windows|win32|win64|wow32|wow64/g.test(userAgent)
    if (isWindows && isSafari) {
      return false;
    }
    return true;
  }
}

export function isIE(): Boolean {
  if (!!window.ActiveXObject || "ActiveXObject" in window)
    return true;
  else
    return false;
}

export const throttled = (fn: Function, wait: number) => {
  let previous = 0
  return (...args: any) => {
    let now = +new Date()
    if (now - previous > wait) {
      previous = now
      fn.apply(this, args)
    }
  }
}
export function getRandomCls(len: number) {
  let str = "",
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  for (let i = 0; i < len; i++) {
    let p = Math.round(Math.random() * (arr.length - 1));
    str += arr[p];
  }
  return str;
}

export const getQueryString = (name: any, str?: any) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  if (!str) {
    str = window.location.search.substr(1);
  }
  let r = str.match(reg);
  if (r != null) return r[2]; return null;
}
export function isObjectEmpty(obj: any) {
  if (!obj || typeof (obj) !== 'object') {
    return false;
  }
  for (var key in obj) {
    return false
  }
  return true
}
export function createUUID() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
export function getStaticPath() {
  return window.location.hostname.indexOf('.develop.') !== -1 ? '' : '/build/passportweb';
}
export function getUploadPath(url: any) {
  if (!url) return '';
  if (url.indexOf('http') === 0) {
    return url;
  }
  if (url.includes('http')) { //feat:过滤老数据含有完整地址参数的url，避免私有化环境不展示图片的问题
    let fIndex = url.indexOf('/papi/file/')
    url = url.slice(fIndex)
  }
  url = url.replace('/api/file/', '/papi/file/');
  if (url && url.indexOf('/papi/file/') !== -1) {
    let hasSecondPath = url.indexOf(publicUrlapi) === 0;
    url = `${window.passport_runInfo?.weappUrl || ''}${hasSecondPath ? '' : publicUrlapi}${url}`;
  } else if (url.indexOf('/static') !== -1) {
    url = `${publicUrlstatic}${url}`;
  }
  return dealImageUrl(url);
}

export const clearCookieByName = function (name: string) {
  let host = window.location.hostname;
  //清理当前域
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  let reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  // 如果不是ip地址访问,逐级域名清理cookie
  if (!reg.test(host)) {
    for (let i = 0; i < host.length; i++) {
      if (host[i] == '.') {
        let domain = host.substr(i);
        document.cookie = name + "=;domain=" + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    }
  }
}
export const setMainHostCookie = (name: string, value: string) => {
  let hostDomian = window.location.hostname;
  if (!isIpHost()) {
    hostDomian = hostDomian.substr(hostDomian.indexOf('.') + 1);
  }
  if (value) {
    document.cookie = name + "=" + value + ";domain=." + hostDomian + ";path=/;";
  } else {
    document.cookie = name + "=" + value + ";domain=." + hostDomian + ";expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
}
export const toCustomloginPage = (props: any, keepSearch?: boolean) => {
  const customloginKey = getQueryString("wea_link_keep_customlogin");
  if (loginStore?.loginActiveKey === 'autoLogin') {//清除pc自动登录标记。修复返回登录跳转失败问题
    loginStore.updateActiveConfigKey && loginStore.updateActiveConfigKey('accountAndPassword');
  }
  let params = '';
  if (keepSearch) {
    params = window.location.search;
  }
  if (props) {
    props.history.push(`${publicUrl}${customloginKey ? `/customlogin/${customloginKey}` : '/login'}${params}`)
  } else {
    window.location.href = `${publicUrl}${customloginKey ? `/customlogin/${customloginKey}` : '/login'}${params}`
  }
}

export const getBrowserLangType = (langType: string) => {//
  if (!langType) return 'zh_CN';
  if (langType === "zh-TW" || langType === "zh-HK" || langType === "zh-SG") {
    return "zh_TW"
  }
  const langTypeKey = langType.split('-')[0].toLocaleLowerCase();
  const langTypePool = [
    'zh_CN',
    'en_US',
    'zh_TW',
    'ko_KR',
    'ru_RU',
    'ja_JP',
    'th_TH',
    'es_ES',
    'de_DE',
    'fr_FR',
    'pt_PT',
    'ar_AE'];
  return langTypePool.find(type => type.indexOf(langTypeKey) === 0) || 'zh_CN'
}

export function isIframeOpen() {
  return window.self?.frameElement?.tagName == "IFRAME";
}

/*
* pc客户端
*/
export function inPCClient() {
  if (localStorage.getItem("___test_client") === "true") {
    return true;
  }
  return /weapp-pc/i.test(window.navigator.userAgent);
}

export function isClientWindows() {
  if (localStorage.getItem("___test_client") === "true") {
    return true;
  }
  return inPCClient() && window.weappUtils?.ua?.os === "Windows";
}

export function isClientMac() {
  return inPCClient() && window.weappUtils?.ua?.os === "Mac";
}
//新版pc客户端判断方法
function isElectron() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('electron') > 0 && userAgent.indexOf('weapp-pc') > 0;
}
function isWindows() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /windows nt/.test(userAgent);
}
export function isFrameLess(isFullscreen?: boolean) {	//是否新版无边框客户端
  if (localStorage.getItem("___test_client") === "true") {
    return true;
  }
  if (isIframeOpen()) {
    return false;
  }
  return !!window.__ET_CLIENT_NO_TITLE
}
export function canCreateTenant() {
  if (window.passport_runInfo?.singleTenant === 'true') {
    return false;
  }
  if (window.passport_runInfo?.createTenant === 'false' && !isE10Self()) {
    return false;
  }
  if (window.passport_runInfo?.onlyMainTenantCreate === 'on') {
    return false;
  }
  return true;
}

export function isWeappYunTeams() {
  return window.location.host.indexOf('passport.yunteams.cn') === 0;
}

export function isEcologyEnv() {
  return window.location.host === 'www.e-cology.com.cn'
}

export function aesEncrypt(text: string) {
  let key = CryptoJS.enc.Hex.parse(CryptoJS.SHA1(CryptoJS.SHA1(AES_PUBLIC_KEY)).toString().substring(0, 32));

  let bytes = CryptoJS.AES.encrypt(text, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return bytes.ciphertext.toString()
}

export function aesDecrypt(encrypted: string) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted);
  let encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let key = CryptoJS.enc.Hex.parse(CryptoJS.SHA1(CryptoJS.SHA1(AES_PUBLIC_KEY)).toString().substring(0, 32));
  let decryptedBytes = CryptoJS.AES.decrypt(encryptedBase64Str, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return decryptedBytes.toString(CryptoJS.enc.Utf8)
}

export function getFilePreviewUrl(fileId: string, type: string = 'imgs') {
  return `${window.passport_runInfo?.weappUrl || ''}${publicUrlapi}/papi/file/preview?fileId=${fileId}&type=${type}`;
}

//文件权限改造兼容处理老数据
//url可能是静态资源（/static/**）、老数据（/api/file/noauth/**、/papi/file/noauth/**）
export function dealImageUrl(url: string) {
  if (!url) {
    return "";
  }
  if (url?.indexOf("/") === -1) {
    return getFilePreviewUrl(url);
  }
  return url.replace('/papi/file/noauth/', '/papi/file/preview?type=imgs&fileId=');
}

export function isE10Self() {
  return window.location.host === 'www.e-cology.com.cn'
}

export function isCustomPageOrCusDomain() {
  //暂时以有无tenantKey判断是否为个性化登录页或者独立域名登录页
  return window.e_customPageData?.tenantKey && window.e_customPageData?.tenantKey !== 'all_teams'
}


export function isCustomLoginPath() {
  return window.location.pathname.replace(publicUrl, '').indexOf('/customlogin/') === 0;
}

export function getCustomLoginKey() {
  if (isCustomLoginPath()) {
    return window.location.pathname.replace(publicUrl, '').replace('/customlogin/', '')
  }
  return null;
}

//是否绕过统一认证拦截
export function isPassIntunifyAuth() {
  const service = getQueryString('service');
  const serviceStr = decodeURIComponent(service);

  const isServiceFreePass = service && (
    serviceStr.indexOf('intunifyauth_client=freepass') !== -1 ||
    serviceStr.indexOf('wea_link_keep_intunifyauth_client=freepass') !== -1
  );

  const isPassIntunifyauth = (
    getQueryString('intunifyauth_client') === 'freepass' ||
    getQueryString('wea_link_keep_intunifyauth_client') === 'freepass' ||
    isServiceFreePass
  );
  return isPassIntunifyauth;
}
